export function totalPostedPaymentsForProject(payments, bills, projectId) {
  const projectByBillId = new Map(bills.map((bill) => [bill.id, bill.project_id || null]));

  return payments.reduce((total, payment) => {
    if (payment.status !== "POSTED") return total;

    return total + (payment.allocations || []).reduce((paymentTotal, allocation) => {
      const billId = allocation.purchase_bill_id || allocation.service_bill_id;
      if (!billId || !projectByBillId.has(billId)) return paymentTotal;

      const billProjectId = projectByBillId.get(billId);
      const matchesProject = projectId === "all"
        ? Boolean(billProjectId)
        : projectId === "none"
          ? !billProjectId
          : billProjectId === projectId;

      return matchesProject ? paymentTotal + Number(allocation.amount || 0) : paymentTotal;
    }, 0);
  }, 0);
}
